module.exports = __webpack_public_path__ + "static/media/xuyingming_match_01.3b711e34.png";